import { render, staticRenderFns } from "./SettingsFontSize.vue?vue&type=template&id=be9e2312&"
import script from "./SettingsFontSize.vue?vue&type=script&lang=js&"
export * from "./SettingsFontSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports